import { render, staticRenderFns } from "./JWL_ProgrammeCertificateExport.vue?vue&type=template&id=78610153&"
import script from "./JWL_ProgrammeCertificateExport.vue?vue&type=script&lang=ts&"
export * from "./JWL_ProgrammeCertificateExport.vue?vue&type=script&lang=ts&"
import style0 from "./JWL_ProgrammeCertificateExport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports